const Routes = {
  Home: '/',
  Start: '/start',
  Daily: '/daily',
  RiskTest: '/risk-test',
  HowItWorks: '/how-it-works',
  IAmSick: '/i-am-sick',
  EmergencyNumbers: '/numbers',
  NoRiskInformation: '/risk-information/no_risk',
  PrivacyPolicy: '/privacy-policy',
  PrivacyPolicyDetails: '/privacy-policy-details',
  Settings: '/settings',
  Regulations: '/regulations',
  Diagnosis: '/diagnosis',
  UserData: '/user-data',
  UserDataChange: '/user-data/change',
  UserDataSettings: '/user-data/settings',
  HospitalsList: '/hospitals-list',
  ReportBug: '/report-bug',
  AdviceInformation: '/advice',
  FaqPage: '/faq'
};

export default Routes;
